import { PillProps, Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import styled from "styled-components"

export const Wrapper = styled.div`
  align-items: center;
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  column-gap: 8px;
  display: grid;
  justify-items: start;
  padding: 16px 20px;
  row-gap: 8px;
  width: 100%;
`

export const Main = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  width: 100%;
`

export const Left = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  ${({ $hasImage }: { $hasImage: boolean }) =>
    $hasImage ? "grid-template-columns: 80px 1fr;" : ""};
`

export const Text = styled.div`
  display: grid;
  row-gap: 4px;
`

export const Label = styled(Typography.H3)`
  font-size: 18px;
  font-weight: 700;
`

export const Subtitles = styled.div`
  display: grid;
`

export const SubtitlePrimary = styled(Typography.SubtitleH3)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.main};
`

export const SubtitleSecondary = styled(SubtitlePrimary)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.light};
  font-size: 14px;
`

export const Buttons = styled.div`
  column-gap: 8px;
  display: grid;
  grid-template-columns: auto auto;
`

export const StatusGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`
